import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import AddResidentAccountNumbers from './components/AddResidentAccountNumbers';


const { Cell } = ResponsiveGrid;

const ResidentAccountNumbers = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="住戶建立戶號"
        // description="住戶建立戶號"
        breadcrumbs={[
          {
            name: '社區管理',
          },
          {
            name: '住戶建立戶號',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <AddResidentAccountNumbers />
    </Cell>

    
  </ResponsiveGrid>
);

export default ResidentAccountNumbers;
